import React from 'react';
import './Modals.scss';

const SuccessMessageModal = ({message}) => (
  <div className="cb-notification animateMessage moduleAlert" role="alert" aria-labelledby="successModal" id='successMessageModal' style={{display:'none'}}>
    <div className="cb-notification-container">
      <div className="cb-notification-header">
        <span className="cb-icon cb-icon-circular cb-check cb-green3-color" aria-hidden="true"></span>
        <h4 className="cb-notification-title" id="successModal">{message}</h4>
      </div>
    </div>
  </div>
);
export default SuccessMessageModal;